import React from "react";

// Modify path,title, icons, subnav according to project
export const TresData = [
  {
    title: "Dashboard",
    path: "/tresDashboard",
    icon: <i className="fa-solid fa-home"></i>,
  },

  {
    title: "Sacco Savings",
    path: "/tresShgSavings",
    icon: <i className="fa-solid fa-sack-dollar"></i>,
  },
  {
    title: "Sacco Loans",
    path: "/tresLoans",
    icon: <i className="fa-solid fa-hand-holding-usd"></i>,
  },
];
